module.exports = __webpack_public_path__ + "static/media/294013.96478def.png";